module.exports = __webpack_public_path__ + "img/new_26.c85173ea.jpg";